<script setup lang="ts">
import CurrentUser from '@/views/header/CurrentUser.vue';
import ZZC from '@/views/header/ZZCLogo.vue';
import VersionComponent from '@/views/header/VersionComponent.vue';
import CabLink from '@/views/header/CabLink.vue';
import {onMounted, onUnmounted} from 'vue';
import {done, loadingState, reload} from '@/base/loadingState.js';
import LoadingStateView from '@/views/general/LoadingStateView.vue';
import {stateForReporters, fetchAndSetState, startStatePolling, stopStatePolling} from '@/base/TMP_globalState.js';
import {AvailabilityState} from 'common';

// Placeholder badge values for demonstration; replace with real data as needed
const numTeAccepteren = 0;
const numGeaccepteerd = 0;
const numAfgewezen = 0;

onMounted(async () => {
    await reload();
    await fetchAndSetState();
    startStatePolling();
});

onUnmounted(() => {
    stopStatePolling();
});
</script>

<template>
    <div class="h-screen relative">
        <VersionComponent/>

        <div class="flex flex-row backdrop-brightness-90 justify-between" id="mainheader">
            <ZZC/>
            <div class="flex flex-row items-end space-x-4">
                <CabLink name="te doen" to="/accept/te-doen" :badge-value="numTeAccepteren" badge-color="blue"/>
                <CabLink name="geaccepteerd" to="/accept/geaccepteerd" :badge-value="numGeaccepteerd" badge-color="green"/>
                <CabLink name="afgewezen" to="/accept/afgewezen" :badge-value="numAfgewezen" badge-color="red"/>
            </div>
            <CurrentUser/>
        </div>
        <LoadingStateView :state="loadingState" :stateForReporters="stateForReporters"/>
        <router-view v-if="done && stateForReporters!==AvailabilityState.closed"/>
    </div>
</template>
